import { MenuItem, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styled button for any dropdown field.
 */
export const DropdownField = styled('button')(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.white,
    border: `2px solid ${HelixPalette.neutral50}`,
    borderRadius: '0.5rem',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '2.5rem',
    overflow: 'hidden',
    padding: '8px 8px 8px 12px',
    position: 'relative',
    width: '100%',
    '[data-dropdown-field-divider=true]': {
        borderRightColor: HelixPalette.neutral50,
        borderRightWidth: '2px',
        margin: '0 0.75rem 0 0.5rem',
    },
    ':not([data-error=true]):not(:disabled)': {
        '&:hover': {
            borderColor: HelixPalette.teal40,
            '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.teal40 },
        },
        '&:focus': { outline: 'none' },
        '&:active:focus': {
            borderColor: HelixPalette.teal60,
            '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.teal60 },
        },
        '&:focus-visible, &.active': {
            outline: HelixStyles.focusVisible4.outline,
            outlineOffset: HelixStyles.focusVisible4.outlineOffset,
            borderColor: HelixPalette.teal50,
            '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.teal50 },
        },
        '&[aria-expanded=true]': {
            borderColor: HelixPalette.teal50,
            '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.teal50 },
        },
    },
    ':not(:disabled)': {
        '&[data-error=true]': {
            borderColor: HelixPalette.danger,
            '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.danger },
            '&:focus-visible, &.active': {
                outline: HelixStyles.focusVisible4.outline,
                outlineOffset: HelixStyles.focusVisible4.outlineOffset,
            },
        },
    },
    '&[data-small=true]': {
        borderRadius: '0.25rem',
        height: '24px',
        minHeight: 'auto',
        padding: '0 0 0 0.25rem',
    },
    '&:disabled': {
        backgroundColor: HelixPalette.neutral10,
        borderColor: HelixPalette.neutral50,
        color: HelixPalette.neutral50,
        cursor: 'not-allowed',
        '[data-dropdown-field-divider=true]': { borderRightColor: HelixPalette.neutral50 },
    },
}));
// ***************************************************** MenuItem **************************************************************
/**
 * Styled MenuItem.
 */
export const DropdownMenuItem = styled(MenuItem)(() => ({
    backgroundColor: HelixPalette.white,
    border: '2px solid transparent',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: '0.125rem 0.375rem',
    '&.MuiButtonBase-root': { minHeight: '26px' },
    '&[aria-selected="true"]': {
        backgroundColor: HelixPalette.white,
        '&:hover': { backgroundColor: HelixPalette.neutral05 },
    },
    '&[aria-selected="false"]': { backgroundColor: HelixPalette.white },
    '&[aria-selected="true"].Mui-focusVisible': { backgroundColor: HelixPalette.white },
    '&.Mui-focusVisible': {
        backgroundColor: HelixPalette.white,
        borderColor: HelixPalette.blue70,
    },
    '&:active:focus:not([aria-disabled="true"].Mui-disabled, &[data-readonly].Mui-disabled)': {
        backgroundColor: HelixPalette.neutral10,
        color: HelixPalette.neutral90,
    },
    '&[data-readonly].Mui-disabled, &[aria-disabled="true"].Mui-disabled': {
        opacity: 1,
        backgroundColor: HelixPalette.neutral10,
        '.MuiTypography-root': { color: HelixPalette.neutral50 },
    },
    '&:hover': { backgroundColor: HelixPalette.neutral05 },
}));
